module.exports = __webpack_public_path__ + "img/image13.1e84fc4b.png";